/** Event of a takeover offer notification (NotificationTypes.TAKEOVER_OFFER_UPDATE); copy of the shared enum */
export enum TakeoverOfferUpdateEvents {
    ACCEPTED = 'accepted',
    DECLINED = 'declined',
    ALL_DECLINED = 'allDeclined',
    EXPIRED = 'expired',
    CONFIRMED = 'confirmed',
    ACCEPTANCE_REJECTED = 'acceptanceRejected',
}
